import React, { useContext, useState, useEffect } from "react";
import { StoreContext } from "../../context/store";
import BankInfomationForm from "./components/BankInfomationForm";
import ShowBankInformation from "./components/ShowBankInformation";
import VerifyForm from "./components/VerifyForm";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import { Typography } from "@material-ui/core";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import successGif from "../../images/successGiff.gif";
import {
  verifyChangeBankAPI,
  getInfomationPolicyAPI,
  verifyChangePromptPayAPI,
} from "./RefundService/refundService";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../util/Notification";
import "./refundPolicy-styles.css";
import { Grid } from "@mui/material";
import CryptoJS from 'crypto-js';

function getSteps() {
  return ["กรอกข้อมูล", "ยืนยันข้อมูล", "สำเร็จ"];
}

const EditBank = () => {
  const {
    informationEditBank,
    updateInformationEditBank,
    informationEditPromptPayAccount,
    updateInformationEditPromptPay,
  } = useContext(StoreContext);
  const [activeStep, setActiveStep] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const steps = getSteps();

  const location = useLocation();
  const dataParams = location.state || {};

  const policyNo = dataParams.policyNo || "";
  const channelType = dataParams.channelType || "";
  const age = dataParams.age || "";
  let navigate = useNavigate();
  const customerName = `${localStorage.getItem("first_name") || ""} ${
    localStorage.getItem("last_name") || ""
  }`;

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const username = decryptCardNumber(localStorage.getItem("customer_id"),process.env.REACT_APP_ENCRYPT_DATA)

  const handleLoading = () => {
    setLoading(!loading);
  };

  const verifyChangeBank = async () => {
    let result = {};
    if (channelType === "bank") {
      result = await verifyChangeBankAPI(informationEditBank);
    } else {
      result = await verifyChangePromptPayAPI(informationEditPromptPayAccount);
    }
    if (result.status === true) {
      notifySuccess(result.meg);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setLoading(false);
      let bank = {
        bank_account_name: "", // ชื่อ-นามสกุล
        bank_account: "", // เลขธนาคาร
        bank_name: "", // ชื่อธนาคาร
        bank_account_file_name: "", // ชื่อไฟล์
        bank_account_file: "", //ไฟล์
        bank_account_flag_information: false,
      };
      updateInformationEditBank(bank);

      let promptPay = {
        prompt_pay_account_name: "", // ชื่อเจ้าของ
        prompt_pay_account: "", // พร้อมเพย์
        prompt_pay_flag_information: false,
      };
      updateInformationEditPromptPay(promptPay);
    } else {
      notifyError(result.meg);
      setLoading(false);
    }
    // console.log(result);
  };

  const handleNext = () => {
    // console.log(activeStep);

    if (activeStep + 1 === 3) {
      handleLoading();
      verifyChangeBank();
    } else {
      if (activeStep == 0) {
        if (channelType == "bank") {
          if (
            informationEditBank.bank_account_name !== "" &&
            informationEditBank.bank_account !== "" &&
            informationEditBank.bank_name !== "" &&
            informationEditBank.bank_account_file !== ""
          ) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          } else {
            notifyWarning("กรุณากรอกข้อมูล และแนบเอกสารให้ครบถ้วน");
          }
        } else if (channelType == "promptpay") {
          // เติมค่าอัตโนมัติถ้าเว้นว่าง
          const ppName = informationEditPromptPayAccount.prompt_pay_account_name?.trim();
          const ppAcc  = informationEditPromptPayAccount.prompt_pay_account?.trim();
        
          const autoName = ppName || (customerName?.trim() || "");
          const autoAcc  = ppAcc  || (username?.trim() || "");
        
          // sync กลับเข้า state (กันยิง payload ว่าง)
          if (!ppName || !ppAcc) {
            updateInformationEditPromptPay({
              ...informationEditPromptPayAccount,
              prompt_pay_account_name: autoName,
              prompt_pay_account: autoAcc,
            });
          }
        
          // validate หลังออโต้กรอก
          if (!autoName || !autoAcc) {
            notifyWarning("กรุณากรอกข้อมูล และแนบเอกสารให้ครบถ้วน");
            return;
          }
        
          // ถ้าพร้อมเพย์ตั้งใจใช้เลขบัตร ปชช. ให้เช็คความยาว 13 หลัก
          if (autoAcc.replace(/\D/g, "").length !== 13) {
            notifyWarning("เลขประจำตัวประชาชน/พร้อมเพย์ต้องมี 13 หลัก");
            return;
          }
        
          setActiveStep((prev) => prev + 1);
        }
        
      } else if (activeStep + 1 == 2) {
        if (channelType == "bank") {
          if (!informationEditBank.bank_account_flag_information) {
            notifyWarning("กรุณายินยอมเงื่อนไขก่อนทำการกดยืนยัน");
          } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          }
        }

        if (channelType == "promptpay") {
          if (!informationEditPromptPayAccount.prompt_pay_flag_information) {
            notifyWarning("กรุณายินยอมเงื่อนไขก่อนทำการกดยืนยัน");
          } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          }
        }
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1, {
        state: {
          policyNo: policyNo,
          age: age,
        },
      });
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const goToHome = () => {
    navigate("/home");
  };

  const handleInfomationPolicy = async () => {
    const result = await getInfomationPolicyAPI(policyNo);

    if (result.result.status === true) {
      if (channelType == "promptpay") {
        const {
          prompt_pay_account_name,
          prompt_pay_account,
          prompt_pay_flag_information,
        } = result.result.data || {};
        updateInformationEditPromptPay({
          prompt_pay_account_name: (prompt_pay_account_name || customerName || "").trim(),
          prompt_pay_account: (prompt_pay_account || username || "").trim(),
          prompt_pay_flag_information: !!prompt_pay_flag_information,
        });
      } else {
        const {
          bank_account_name,
          bank_account,
          bank_name,
          bank_account_flag_information,
        } = result.result.data || {};
        updateInformationEditBank({
          bank_account_name: bank_account_name || "",
          bank_account: bank_account || "",
          bank_name: bank_name || "",
          bank_account_flag_information: !!bank_account_flag_information,
        });
      }
    }    
  };

  useEffect(() => {
    handleInfomationPolicy();
    console.log(informationEditPromptPayAccount.prompt_pay_account.length);
  }, []);

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <BankInfomationForm channelType={channelType} age={age} />;
      case 1:
        return <ShowBankInformation channelType={channelType} age={age} />;
      case 2:
        return <VerifyForm channelType={channelType} age={age} />;
      default:
        return "Unknown step";
    }
  }

  return (
    <>
      <Header_Home />
      <Header title="เงินคืนตามเงื่อนไขกรมธรรม์" />
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      )}
      <div className="containers px-4 pt-5">
        <div className="card-change-pay big-frame-change-pay h-auto mb-10">
          <div className="d-flex px-3 pt-3 pb-3">
            <h2 className="font-size-title">
              {activeStep === 0
                ? "กรอกข้อมูล"
                : activeStep === 1
                ? "ยืนยันข้อมูล"
                : activeStep === 2
                ? "ยืนยัน OTP"
                : ""}
            </h2>
          </div>
          {activeStep !== 3 && (
            <hr
              className="mx-2"
              style={{ margin: "0px 0px 15px 0px", border: "solid 1px" }}
            />
          )}
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel className="font-size-title">
                  <p className="font-new">{label}</p>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <>
              <Typography variant="h3" align="center">
                <img
                  src={successGif}
                  alt={"confirmGif"}
                  style={{
                    height: "auto",
                    marginTop: "5%",
                    marginBottom: "5%",
                    width: "20%",
                  }}
                />
                <li
                  className="body-list-group"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Col
                    xl={12}
                    md={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    <h3 className="bold">บันทึกข้อมูลสำเร็จ</h3>
                  </Col>
                </li>
                <li
                  className="body-list-group"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Col
                    xl={12}
                    md={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      fontSize: 15,
                    }}
                  >
                    <span className="light">
                      บริษัทฯ จะดำเนินการโอนเงินตามเงื่อนไขกรมธรรม์
                      โดยอัตโนมัติผ่านบัญชีธนาคารที่คุณได้ระบุไว้
                      กรณีเปลี่ยนแปลงข้อมูลบัญชีธนาคารจะต้อง
                      แก้ไขข้อมูลก่อนจ่ายเงินคืนตามเงื่อนไขกรมธรรม์ ล่วงหน้า 15
                      วัน
                    </span>
                  </Col>
                </li>
              </Typography>
              <Row className="d-flex  flex-column mb-5">
                <Col className="d-flex justify-content-center px-5">
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={6}>
                      <button
                        onClick={goToHome}
                        type="button"
                        className="btn-checkout-premium w-sm-100 w-lg-25 p-2 bold"
                      >
                        กลับสู่หน้าหลัก
                      </button>
                    </Grid>
                  </Grid>
                </Col>
              </Row>
            </>
          ) : (
            <div>
              <div className="p-3">{getStepContent(activeStep)}</div>
            </div>
          )}
        </div>
        {activeStep !== 3 && (
          <Row
            className="d-flex flex-column mt-2 mb-5"
            style={{ marginBottom: 75 }}
          >
            <Col className="d-flex justify-content-end px-5 gap-2">
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <input
                    type="submit"
                    style={{ fontSize: 15 }}
                    onClick={handleNext}
                    value="ยืนยัน"
                    className="btn-checkout-premium w-100 p-2 bold"
                    disabled={
                      activeStep === 1 && (
                        (channelType === "bank" && !informationEditBank.bank_account_flag_information) ||
                        (channelType === "promptpay" && !informationEditPromptPayAccount.prompt_pay_flag_information)
                      )
                    }                    
                  ></input>
                </Grid>
              </Grid>
            </Col>
            <Col className="d-flex justify-content-start px-5">
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <button
                    onClick={handleBack}
                    type="button"
                    className="btn-checkout-back w-100 p-2 bold"
                  >
                    ย้อนกลับ
                  </button>
                </Grid>
              </Grid>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default EditBank;
